import {
  getLeafNode,
  isCollapsed,
  select,
  setNodes,
  unwrapNodes,
  withoutNormalizing,
  wrapNodes,
} from '@udecode/plate-core';
import { getElementEntry } from '../../editorTools/queries';
import { getTElementPlugin } from '../../plate';
import { DreamEditor } from '../../types';
import { validateURL } from '../../utils/url';

// TODO: handle internal link
/**
 * Unwrap link at a location (default: selection).
 * Then, the focus of the location is set to selection focus.
 * Then, wrap the link at the location.
 */
export function upsertLinkAtSelection(
  editor: DreamEditor,
  data: { url: string, pageID?: string, pagePath?: string },
) {
  if (!editor.selection) return;

  const link = getTElementPlugin(editor, 'a');

  // if our cursor is inside an existing link, but don't have the text selected, select it now
  if (isCollapsed(editor.selection)) {
    const [, path] = getLeafNode(editor, editor.selection);
    select(editor, path);
  }

  withoutNormalizing(editor, () => {
    const insertedURL = validateURL(data.url);

    unwrapNodes(editor, {
      at: editor.selection!,
      match: { type: link.type },
    });

    if (data.pageID && typeof data.pagePath === 'string') {
      wrapNodes(
        editor,
        {
          type: link.type!,
          url: data.pagePath,
          internal_link: true,
          page_id: data.pageID,
          children: [],
        },
        { at: editor.selection!, split: true },
      );
      return;
    }

    wrapNodes(
      editor,
      {
        type: link.type!,
        url: insertedURL,
        children: [],
      },
      { at: editor.selection!, split: true },
    );
  });
}

export function toggleOpenInNewTabAtSelection(editor: DreamEditor) {
  if (!editor.selection) return;

  const elementEntry = getElementEntry(editor);
  if (!elementEntry || elementEntry[0].type !== 'a') return;

  const [element, path] = elementEntry;

  setNodes(
    editor,
    { open_in_new_tab: !element.open_in_new_tab },
    { at: path },
  );
}

export function removeLinkAtSelection(editor: DreamEditor) {
  if (!editor.selection) return;

  unwrapNodes(editor, {
    match: { type: 'a' },
    at: editor.selection,
  });
}
